import React from "react";
import { SectionContentProps } from "../../types";
import EditableText from "../../core/EditableText";
import { UniversityAbout } from "../../university";
import { CollegeAbout } from "../../college";
import { HokChooseUs } from "../../hok";
import OvanAbout from "../../ovan/ovanabout/OvanAbout";

export default function AboutSection({ content, onContentChange, isSelected, defaultLogo }: SectionContentProps) {
    if (content?.variant === "ovan") {
        return <OvanAbout content={content} onContentChange={onContentChange} isSelected={isSelected} />;
    }

    if (content?.variant === "hok") {
        return <HokChooseUs content={content} onContentChange={onContentChange} isSelected={isSelected} />;
    }

    if (content?.variant === "college") {
        return (
            <CollegeAbout
                content={content}
                onContentChange={onContentChange}
                isSelected={isSelected}
            />
        );
    }

    if (content?.variant === "university") {
        return (
            <UniversityAbout
                content={content}
                onContentChange={onContentChange}
                isSelected={isSelected}
                defaultLogo={defaultLogo}
            />
        );
    }

    const primaryColor = content.colorPalette?.primary || "#3B82F6";
    const fontFamily = content.fontFamily || "'Inter', sans-serif";

    return (
        <div
            className={`bg-white px-8 py-24 ${isSelected ? "ring-2 ring-blue-500" : ""}`}
            style={{ fontFamily }}
        >
            <div className="mx-auto max-w-4xl text-center">
                {content.subtitle && (
                    <p
                        className="text-sm font-bold uppercase tracking-widest mb-4"
                        style={{ color: primaryColor }}
                    >
                        {content.subtitle}
                    </p>
                )}
                <h2 className="mb-6 text-3xl md:text-5xl font-bold text-gray-900 leading-tight">
                    <EditableText
                        value={content.title || "About Us"}
                        onChange={(val) => onContentChange?.({ ...content, title: val })}
                        as="span"
                        placeholder="Title"
                    />
                </h2>
                <div
                    className="w-24 h-1.5 mx-auto rounded-full mb-10"
                    style={{ background: primaryColor }}
                />
                <p className="text-xl md:text-2xl text-gray-600 leading-relaxed font-light">
                    <EditableText
                        value={content.description || "We are dedicated to excellence and innovation, providing top-tier solutions for modern businesses around the globe."}
                        onChange={(val) => onContentChange?.({ ...content, description: val })}
                        as="span"
                        placeholder="Description..."
                    />
                </p>

                {content.imageUrl && (
                    <div className="mt-12 rounded-2xl overflow-hidden shadow-xl">
                        <img src={content.imageUrl} alt="About" className="w-full h-auto" />
                    </div>
                )}
            </div>
        </div>
    );
}
